import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CommentIcon } from '@business/assets/vectors/comment-icon.svg';
import { SVGAssets } from '@business/assets/vectors';
import { MediaStatsProps } from '@business/interfaces/photo';
import { Button } from '@business/workflows/ComponentUI';

const MediaStats: React.FC<MediaStatsProps> = ({
  likes = 0,
  comments = 0,
  shares = 0,
  onLike,
  onComment,
  onShare,
  isLiked = false,
  isSharing,
  isAssetOwner,
  isMediaOwner
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-6 px-6 py-3 bg-black text-sm text-gray-200">
      <div className="flex items-center gap-2">
        <Button
          className="flex items-center justify-center hover:opacity-80 transition"
          aria-label={t('mediaView.like')}
          onClick={onLike}
          btnStyle="no-outline">
          <span
            className={`text-xl ${isLiked ? 'text-red-500' : 'text-gray-400'}`}>
            ❤
          </span>
        </Button>
        <span className="text-white">{likes}</span>
      </div>

      <div className="flex items-center gap-2">
        <Button
          className="flex items-center justify-center hover:opacity-80 transition"
          aria-label={t('mediaView.comment')}
          onClick={onComment}
          btnStyle="no-outline">
          <CommentIcon className="w-5 h-5 fill-gray-400" />
        </Button>
        <span className="text-white">{comments}</span>
      </div>
      {(isAssetOwner || !isSharing) && isMediaOwner && (
        <div className="flex items-center gap-2">
          <Button
            className="flex items-center justify-center hover:opacity-80 transition"
            aria-label={t('mediaView.share')}
            onClick={onShare}
            btnStyle="no-outline">
            <SVGAssets.Diary className="w-5 h-5 fill-gray-400" />
          </Button>
          <span className="text-white">{shares}</span>
        </div>
      )}
    </div>
  );
};

export default MediaStats;
